import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, tap } from 'rxjs';

import { StaticApplicationId, SvcViewsService } from 'projects/lib-shared-core/src/public-api';

const FEATURE_NAME = 'view-action-plan';

@Injectable({ providedIn: 'root' })
export class SvcActionPlanCounterService {
  readonly #viewsService = inject(SvcViewsService);

  /**
   * Plans already registered in this app session. The backend dedupes views
   * per user anyway, so reopening the same plan doesn't need another POST —
   * skipping it also skips the follow-up totals refresh, saving both requests.
   */
  readonly #registeredViewIds = new Set<number>();

  public registerView(actionPlanUniqueId: number): Observable<boolean> {
    if (this.#registeredViewIds.has(actionPlanUniqueId)) return EMPTY;

    return this.#viewsService
      .setViews({
        registryId: `${actionPlanUniqueId}`,
        applicationId: StaticApplicationId.actionPlanRevamp,
        featureName: FEATURE_NAME,
      })
      .pipe(tap(() => this.#registeredViewIds.add(actionPlanUniqueId)));
  }
}
